<template>
  <div class="wrapperjdzf">
        <Module ref="Module"
        :title="''"
        :desc="''"
        :moreTitle="'更多阶段涨幅'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :checkData="checkData"
        :loadStyle="'height: 315px'"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">
            <div :class="[showUpdate ? 'singleUpdate top' : 'single top']">
              <span class="period toptitle">周期</span>
              <span class="syl toptitle">涨跌幅</span>
              <!-- <span class="avg toptitle">同类平均</span>
              <div class="headRank">
                <div class="toptitle">同类排行</div> -->
              <div class="headRank" @click="clickNewFLtip">
                <div class="toptitle">同类平均
                  <img class="warn-tip-gray-gx"
                src='@/assets/warn-tip-gray.png'/>
                </div>
              </div>
              <div class="headRank">
                <div class="toptitle" @click="clickNewRankFLtip">同类排行
                  <img class="warn-tip-gray-gx"
                src='@/assets/warn-tip-gray.png'/>
                </div>
                <div class="headRankUpdate" @click="clickGxtip" v-if="showUpdate" >更新中
                  <img class="warn-tip-gray-gx"
                src='@/assets/warn-tip-gray.png'/>
                </div>
              </div>
            </div>
            <div class="singlecell bottom"
            v-for="(item, index) in slotProps.list" v-bind:key="index">
              <span class="period">{{item.title}}</span>
              <span :class="['syl', `${upDown(item.syl)}`]">{{configPercentV(item.syl)}}</span>
              <span :class="['avg', `${upDown(item.avg)}`]">{{configPercentV(item.avg)}}</span>
              <div class="rank-wrap">
                <div class="rank-top" @click="clickRank(item)">
                  <span style="rank">{{item.rank}}</span>
                  <span class="sc">{{` / `}}</span>
                  <span class="sc">{{item.sc}}</span>
                </div>
                <div class="rank-bottom" v-if="item.rankDesc">
                  <span class="dec">{{item.rankDesc}}</span>
                </div>
              </div>
            </div>
          </div>
        </Module>
  </div>
</template>

<style lang="less" scoped>
.wrapperjdzf {
  background-color: white;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 12px;
}
.single {
  display: flex;
  justify-content: space-between;
  height: 90px;
  align-items: center;
}
.singleUpdate {
  display: flex;
  justify-content: space-between;
  height: 90px;
}
.toptitle{
  line-height: 35px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.singlecell {
  font-family: DINAlternate-Bold;
  display: flex;
  font-size: 30px;
  min-height: 90px;
  &:nth-last-child(1) {
  &:after{
    display: none;
  }
  }
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.top {
  color: #999999;
  font-size: 28px;
  .period {
    text-align: left;
    width: 20%;
  }
  .syl {
    text-align: center;
    width: 20%;
  }
  .avg {
    text-align: center;
    width: 24%;
  }
  .rank {
    text-align: right;
    width: 30%;
  }
}
.headRankavg{
  flex-shrink: 0;
  text-align: right;
  width: 24%;
  flex-direction: column;
  display: flex;
}
.headRank{
  flex-shrink: 0;
  text-align: right;
  width: 30%;
  flex-direction: column;
  display: flex;
}
.headRankUpdate{
  margin-top: 10px;
  color: #ff4400
}
.warn-tip-gray-gx {
    width: 26px;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }
.bottom {
  font-size: 30px;
  .period {
    font-family: PingFangSC-Regular;
    text-align: left;
    display: flex;
    margin-top: 15px;
    width: 20%;
  }
  .syl {
    font-size: 32px;
    text-align: center;
    display: flex;
    margin-top: 15px;
    justify-content: center;
    width: 20%;
  }
  .avg {
    font-size: 32px;
    text-align: center;
    display: flex;
    margin-top: 15px;
    justify-content: center;
    width: 30%;
  }
  .rank-top{
    font-size: 32px;
  }
  .rank-bottom{
    font-size: 32px;
  }
  .rank-wrap {
    flex-direction: column;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    text-align: right;
    width: 30%;
    .rank {
      color: black;
    }
    .sc {
      color: #666666;
    }
    .dec{
      margin-top: 6px;
      font-size: 24px;
      color: #000;
    }
  }
}
.more-wrapper {
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  padding: 30px;
}

.more-text {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #008aff;
  text-align: center;
  line-height: 30px;
}
</style>

<script>
import Module from '@/components/Module.vue';
import StoreManger from '@/utils/FundHQJHManger';
import JS from '@/base/JSTool';
import Util from '@/base/Util';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'mark-period-increase',
  components: {
    Module,
  },
  props: {},
  watch: {},
  data() {
    return {
      pageData: {},
      fundCode: '',
      fundType: '',
      showUpdate: false,
    };
  },
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    mainQueryError() {
      this.$refs.Module.showMainError();
    },
    render(iscache) {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      if (!iscache) {
        this.$refs.Module.start();
      } else {
        this.$refs.Module.cache();
      }
    },
    needRequestData() {
      const fundId = StoreManger.getFundJDZF();
      let needReq = true;
      if (fundId) {
        if (fundId.time) {
          const now = new Date().getTime();
          const during = now - fundId.time;
          console.log(`needRequestData ------during ${during}`);
          if (during < 2 * 60 * 1000) {
            needReq = false;
          }
        }
      }
      console.log(`needRequestData ------needReq ${needReq}`);
      return needReq;
    },
    clickRank(item) {
      const dic = {
        Z: 'SYL_Z',
        Y: 'SYL_Y',
        '3Y': 'SYL_3Y',
        '6Y': 'SYL_6Y',
        '1N': 'SYL_1N',
        '2N': 'SYL_2N',
        '3N': 'SYL_3N',
        '5N': 'SYL_5N',
        JN: 'SYL_JN',
        LN: 'SYL_LN',
        SNH: 'LJJZ',
        FTNH: 'FTYI',
        TENH: 'TEYI',
        TFNH: 'TFYI',
      };
      let tag = dic[item.titleSource];
      if (!tag) {
        tag = 'SYL_Y';
      }
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundSame',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          periodtag: tag,
        },
      });
    },
    fetchCache() {
      const fundId = StoreManger.getFundJDZF();
      return this.handleData(fundId);
    },
    fetchRequest() {
      return new Promise((resolve) => {
        const resData = this.handleData(StoreManger.getFundJDZF());
        resolve(resData);
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
    },
    handleData(item) {
      if (!item) {
        return [];
      }
      if (!item.Datas) {
        return [];
      }
      this.showUpdate = item.Expansion.ISUPDATING;
      const list = item.Datas;
      const arr = [];
      if (list.length > 0) {
        const newList = list.slice(0, 5);
        newList.forEach((el) => {
          arr.push(this.format(el));
        });
      }
      return arr;
    },
    format(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      return {
        title: (() => {
          const res = JS.fetchString(Util.periodMap(), fetch('title'));
          return res || '--';
        })(),
        titleSource: fetch('title'),
        syl: fetch('syl'),
        avg: fetch('avg'),
        rank: fetch('rank'),
        sc: fetch('sc'),
        rankDesc: (() => {
          let res = '';
          const rank = fetch('rank');
          const sc = fetch('sc');
          const descConfig = ['优秀', '良好', '一般', '不佳'];
          const index = Math.ceil((parseFloat(rank) * 4) / parseFloat(sc));
          // eslint-disable-next-line no-restricted-globals
          if (index < 1 || index > 4 || isNaN(index)) {
            res = '';
          } else {
            res = `${descConfig[index - 1]}`;
          }
          return res;
        })(),
      };
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    configPercentV(value) {
      if (value === '--') {
        return '--';
      }
      return `${value}%`;
    },
    navigateTo() {
      detailPushPage({
        appId: 'funda310cd172dd395',
        url: '/pages/questionDetail/index?id=1361',
      });
    },
    clickNewRankFLtip() {
      this.$feedback.showModal({
        title: '',
        content: '平台采用最新同类排行，在原有一级分类基础上按照资产维度向下细分，用更加科学的方法在同一维度内进行对比。如：混合型-偏股、混合型-偏债。',
        confirmText: '知道了',
        cancelText: '了解详情',
        confirmColor: '#ff4400',
        cancelColor: '#000000',
        showCancel: true,
        success: (res) => {
          if (res.confirm) {
            console.log('用户点击确定');
          } else if (res.cancel) {
            console.log('用户点击取消');
            this.navigateTo();
          }
        },
      });
    },
    clickNewFLtip() {
      this.$feedback.showModal({
        title: '',
        content: '平台采用最新同类分类，在原有一级分类基础上按照资产维度向下细分，用更加科学的方法计算平均值做参考。如：混合型-偏股、混合型-偏债。',
        confirmText: '知道了',
        cancelText: '了解详情',
        confirmColor: '#ff4400',
        cancelColor: '#000000',
        showCancel: true,
        success: (res) => {
          if (res.confirm) {
            console.log('用户点击确定');
          } else if (res.cancel) {
            console.log('用户点击取消');
            this.navigateTo();
          }
        },
      });
    },
    clickGxtip() {
      const domin = 'https://helpmob.1234567.com.cn/';
      detailPushPage({
        type: 2,
        url: `${domin}m/q_1327.html?&rand=${Math.floor(Math.random() * 100)}`,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return;
      }
      if (!baseInfo.SHORTNAME) {
        return;
      }
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundStageIncrease',
        params: {
          fundCode: this.fundCode,
          fundName: baseInfo.SHORTNAME,
          isHuobi: 0,
        },
      });
      this.reportMonitor({
        eventName: 'pz.middle.jdzf.more',
      });
    },
  },
};
</script>
